function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LocalStorage } from './local-storage';
export const getVariantStorage = (deploymentKey, instanceName, storage) => {
  const truncatedDeployment = deploymentKey.substring(deploymentKey.length - 6);
  const namespace = `amp-exp-${instanceName}-${truncatedDeployment}`;
  return new LoadStoreCache(namespace, storage, transformVariantFromStorage);
};
export const getFlagStorage = function (deploymentKey, instanceName) {
  let storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new LocalStorage();
  const truncatedDeployment = deploymentKey.substring(deploymentKey.length - 6);
  const namespace = `amp-exp-${instanceName}-${truncatedDeployment}-flags`;
  return new LoadStoreCache(namespace, storage);
};
export class LoadStoreCache {
  constructor(namespace, storage, transformer) {
    _defineProperty(this, "namespace", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "transformer", void 0);

    _defineProperty(this, "cache", {});

    this.namespace = namespace;
    this.storage = storage;
    this.transformer = transformer;
  }

  get(key) {
    return this.cache[key];
  }

  getAll() {
    return { ...this.cache
    };
  }

  put(key, value) {
    this.cache[key] = value;
  }

  putAll(values) {
    for (const key of Object.keys(values)) {
      this.cache[key] = values[key];
    }
  }

  remove(key) {
    delete this.cache[key];
  }

  clear() {
    this.cache = {};
  }

  async load(initialValues) {
    const rawValues = await this.storage.get(this.namespace);
    let jsonValues;

    try {
      jsonValues = JSON.parse(rawValues) || {};
    } catch {
      // Do nothing
      return;
    }

    const values = {};

    for (const key of Object.keys(jsonValues)) {
      try {
        let value;

        if (this.transformer) {
          value = this.transformer(jsonValues[key]);
        } else {
          value = jsonValues[key];
        }

        if (value) {
          values[key] = value;
        }
      } catch {// Do nothing
      }
    }

    this.clear();

    if (initialValues) {
      this.putAll(initialValues);
    }

    this.putAll(values);
  }

  async store() {
    let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.cache;
    await this.storage.put(this.namespace, JSON.stringify(values));
  }

}
export const transformVariantFromStorage = storageValue => {
  if (typeof storageValue === 'string') {
    // From v0 string format
    return {
      key: storageValue,
      value: storageValue
    };
  } else if (typeof storageValue === 'object') {
    // From v1 or v2 object format
    const key = storageValue['key'];
    const value = storageValue['value'];
    const payload = storageValue['payload'];
    let metadata = storageValue['metadata'];
    let experimentKey = storageValue['expKey'];

    if (metadata && metadata.experimentKey) {
      experimentKey = metadata.experimentKey;
    } else if (experimentKey) {
      metadata = metadata || {};
      metadata['experimentKey'] = experimentKey;
    }

    const variant = {};

    if (key) {
      variant.key = key;
    } else if (value) {
      variant.key = value;
    }

    if (value) variant.value = value;
    if (metadata) variant.metadata = metadata;
    if (payload) variant.payload = payload;
    if (experimentKey) variant.expKey = experimentKey;
    return variant;
  }

  return undefined;
};
//# sourceMappingURL=cache.js.map